<template>
  <div class="shortcut-btns shrtbtns">
    <div
      v-if="!minimized"
      class="shrtbtns_btns"
    >
      <component
        :is="btn.component ? 'a' : 'div'"
        v-for="btn in btns"
        :key="btn.id"
        class="icon_btn csst mdi shrtbtns_btns_btn"
        :class="btn.icon"
        v-bind="btn.props || {}"
        :data-tst="`shrtbtn_${btn.id}`"
        @mouseenter="e => fl_positionTooltip(e, { placement: 'right' })"
        @click="
          () => {
            if (btn.fn) {
              btn.fn()
            }
          }
        "
      >
        <div
          class="csst_content text-nowrap"
          style="position: fixed"
          v-html="hasKeys ? btn.tooltip_key : btn.tooltip"
        ></div>
      </component>
    </div>

    <GwMenu
      v-else
      ref="gwmenu"
      class="shrtbtns_menu"
    >
      <template #opener>
        <div
          class="f-center h-100"
          style="background: var(--clr-black-1); border-radius: 4px; padding: 0 0.25rem"
        >
          <div
            v-if="hasExpand"
            class="mdi icon_btn shrtbtns_menu_btn mdi mdi-arrow-expand-vertical csst"
            @click.stop="maximizeHsContainer"
            @mouseenter="e => fl_positionTooltip(e, { placement: 'right' })"
          >
            <div
              class="csst_content text-nowrap"
              v-html="
                $t(`hotkeys.expand_history_key`, {
                  key: hotkeys.expand_history.displayCombination,
                })
              "
            ></div>
          </div>
          <i class="mdi icon_btn shrtbtns_menu_btn mdi mdi-dots-vertical" />
        </div>
      </template>
      <template #default="{ methods }">
        <GwBtns
          :options="btns"
          class="gwbtns_vertical_white gw_menu"
          @click="
            (_e, item) => {
              methods.toggleOpen(false)
              if (item.fn) {
                item.fn()
              }
            }
          "
        >
          <template #default="{ item }">
            <component
              :is="item.component ? 'a' : 'div'"
              v-bind="item.props || {}"
              class="f-center clr-white"
            >
              <i
                class="mdi text-normal mr-2"
                :class="item.icon"
              ></i>
              <div v-html="hasKeys ? item.tooltip_key : item.tooltip"></div>
            </component>
          </template>
        </GwBtns>
      </template>
    </GwMenu>
  </div>
</template>

<script>
import GwMenu from '@/components/lib/GwMenu'
import GwBtns from '@/components/lib/GwBtns'
import links_mix from '@/mixins/links_mix'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'ShortcutsBtns',
  components: {
    GwMenu,
    GwBtns,
  },
  mixins: [links_mix, float_mix],
  props: {
    namespace: { String, required: true },
    // inDialog: Boolean,
    minimized: Boolean,
    // isVertical: Boolean,
    hasExpand: { type: Boolean, default: true },
    hasKeys: { type: Boolean, default: true },
    hiddenBtns: { default: () => [] },
    canAISolve: { required: true, type: Boolean },
  },
  emits: ['reset'],
  data() {
    return {
      // open: false,
    }
  },
  methods: {
    maximizeHsContainer() {
      this.$store.dispatch('globals_fullscreen_local')
      this.$store.dispatch('globals_fullscreen')
      this.open = false
    },
    resetHistory() {
      if (!this.canReset) return
      this.$emit('reset')
    },
    openShortcurts() {
      const dialog = `preflop-shortcut-dialog${
        this.namespace ? `_namespace-${this.namespace}` : ''
      }${this.canAISolve ? `_canAISolve-true` : ''}`
      this.$store.dispatch('router_set_dialogs', dialog)
    },
    openSaveSpotDialog() {
      this.$store.dispatch(
        'router_set_dialogs',
        `saved-spots-dialog${this.namespace ? `_namespace-${this.namespace}` : ''}`,
      )
    },
    handleKeydown(keys) {
      const hotkeyActions = {
        reset_history: {
          keys: this.hotkeys.reset_history.keyCombination,
          fn: () => this.resetHistory(),
        },
        open_shortcuts: {
          keys: this.hotkeys.open_shortcuts.keyCombination,
          fn: () => this.openShortcurts(),
        },
        expand_history: {
          keys: this.hotkeys.expand_history.keyCombination,
          fn: () => this.maximizeHsContainer(),
        },
        save_spot: {
          keys: this.hotkeys.save_spot.keyCombination,
          fn: () => this.openSaveSpotDialog(),
        },
      }
      this.$store.dispatch('hotkeys_perform_action', { keys, hotkeyActions })
    },
  },
  computed: {
    btns() {
      const res = [
        {
          id: 'shortcut',
          icon: 'mdi-bookmark-outline',
          fn: this.openShortcurts,
          tooltip_key: this.$t('hotkeys.open_shortcuts_key', {
            key: this.hotkeys.open_shortcuts.displayCombination,
          }),
          tooltip: this.$t('tooltips.shortcuts_shortcut'),
        },
        {
          id: 'reset_history',
          icon: 'mdi-restart',
          fn: this.resetHistory,
          tooltip_key: this.$t('hotkeys.reset_history_key', {
            key: this.hotkeys.reset_history.displayCombination,
          }),
          tooltip: this.$t('hotkeys.reset_history'),
        },
        {
          id: 'save_spot',
          icon: 'mdi-content-save',
          fn: this.openSaveSpotDialog,
          tooltip_key: this.$t('hotkeys.save_spot_key_tra01', {
            key: this.hotkeys.save_spot.displayCombination,
          }),
          tooltip: this.$t('hotkeys.save_spot_tra01'),
        },
        {
          id: 'practice_spot',
          icon: 'mdi-google-controller',
          props: {
            href: this.links_getLink({
              pathName: 'PracticeTrainer',
              hasBoardFilter: this.$route.name === 'PracticeRangeBuilder',
              namespace: this.namespace,
            }),
            target: '_blank',
          },
          component: 'a',
          tooltip_key: this.$t('tooltips.practice_spot'),
          tooltip: this.$t('tooltips.practice_spot'),
        },
        {
          id: 'expand',
          // is_hidden: !this.hasExpand,
          is_hidden: this.globals_fullscreen ? true : !this.hasExpand,
          icon: 'mdi-arrow-expand-vertical',
          fn: this.maximizeHsContainer,
          tooltip_key: this.$t(
            `${
              this.globals_fullscreen
                ? 'hotkeys.expand_history_key'
                : 'hotkeys.collapse_history_key'
            }`,
            {
              key: this.hotkeys.expand_history.displayCombination,
            },
          ),
          tooltip: this.$t(
            `${this.globals_fullscreen ? 'hotkeys.expand_history' : 'hotkeys.collapse_history'}`,
          ),
        },
      ].filter(btn => !btn.is_hidden && !this.hiddenBtns.includes(btn.id))
      // console.log(res)
      return res
    },
    canReset() {
      const hSpots =
        this.$store.getters[`${this.namespace ? `${this.namespace}/` : ''}history_spots`]
      const res = hSpots[0]?.selected_action_code
      return !!res
    },
    globals_fullscreen() {
      return this.$store.getters.globals_fullscreen
    },
    hotkeys() {
      return this.$store.getters.hotkeys
    },
    // hotkeysAction() { return this.$store.getters.hotkeys_action },
    hotkeysPressed() {
      return this.$store.getters.hotkeys_pressed
    },
  },
  watch: {
    hotkeysPressed(keys) {
      if (!keys) return
      this.handleKeydown(keys)
    },
  },
}
</script>

<style lang="scss" scoped>
.shrtbtns {
  display: flex;
  align-items: center;
  justify-content: center;
  &_menu {
    height: 2.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
    &_btn {
      font-size: 1.25rem;
      padding: 0.25rem;
      color: var(--clr-grey-2);
      &:hover {
        color: var(--clr-white-0);
      }
    }
  }
  &_btns {
    border-radius: 4px;
    background: var(--clr-black-1);
    padding: 0.25em 0;
    min-width: 2rem;
    height: 8.75em;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-around;
    &_btn {
      font-size: 1.125rem;
      padding: 0.25rem;
      color: var(--clr-grey-2);
      &:hover {
        color: var(--clr-white-0);
      }
    }
  }
}
</style>
